<template>
  <div class="transfer-container">
    <el-row :gutter="24">
      <el-col :span="10">
        <el-card :header="leftHeader" class="table-card">
          <el-table
            :data="tableData"
            border
            stripe
            size="mini"
            height="300"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="40" />
            <template v-for="item in dataSrouceColumns">
              <el-table-column :key="item.id" :label="item.name" :prop="item.code" />
            </template>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="3" style="height: 300px">
        <div class="flex-column">
          <el-button size="mini" type="primary" @click="toRight">=></el-button>
          <el-button size="mini" type="primary" @click="toLeft">&lt;=</el-button>
          <el-button size="mini" type="primary" @click="clearAll">清空已选</el-button>
        </div>
      </el-col>
      <el-col :span="11">
        <el-card :header="rightHeader" class="table-card">
          <el-table
            border
            stripe
            size="mini"
            height="300"
            :data="selectedTableData"
            @selection-change="handleSelectedSelectionChange"
          >
            <el-table-column type="selection" width="40" />
            <template v-for="item in dataSrouceColumns">
              <el-table-column :key="item.id" :label="item.name" :prop="item.code" />
            </template>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  props: {
    'leftHeader': {
      type: String,
      default: '渠道列表'
    },
    'rightHeader': {
      type: String,
      default: '已选渠道列表'
    },
    // 数据源
    'dataSrouce': {
      type: [Array, Object],
      default: () => []
    },
    // 数据源表头
    'dataSrouceColumns': {
      type: Array,
      default: () => []
    },
    // 右侧数据源表头
    'rightDataSrouce': {
      type: [Array, Object],
      default: () => []
    },
    'transferType': {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tableData: [],
      selectedTableData: [],
      multipleSelection: [],
      selectedMultipleSelection: []
    }
  },
  watch: {
    'dataSrouce': {
      handler(val) {
        // console.log('watch', val)
        if (val) {
          if (this.transferType === 'area') {
            if (this.dataSrouce?.bases && this.dataSrouce.bases.length > 0) {
              this.tableData = this.dataSrouce.bases.map((item) => {
                item.pdeptCode = this.dataSrouce.deptCode
                item.pdeptName = this.dataSrouce.deptName
                return item
              })
            }
          } else {
            if (this.dataSrouce.length > 0) {
              this.tableData = this.dataSrouce.map((item) => {
                return item
              })
            }
          }
        }
      },
      deep: true
    },
    'rightDataSrouce': {
      handler(val) {
        // console.log('watch', val)
        if (val) {
          if (this.rightDataSrouce.length > 0) {
            this.selectedTableData = this.rightDataSrouce.map((item) => {
              return item
            })
          }
        }
      },
      deep: true
    }
  },
  created() {
    // console.log('created')
    if (this.transferType === 'area') {
      if (this.dataSrouce?.bases && this.dataSrouce.bases.length > 0) {
        this.tableData = this.dataSrouce.bases.map((item) => {
          item.pdeptCode = this.dataSrouce.deptCode
          item.pdeptName = this.dataSrouce.deptName
          return item
        })
      }
    } else {
      if (this.dataSrouce.length > 0) {
        this.tableData = this.dataSrouce.map((item) => {
          return item
        })
      }
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSelectedSelectionChange(val) {
      this.selectedMultipleSelection = val
    },
    toRight() {
      if (this.multipleSelection.length) {
        const multipleSelection = this.multipleSelection.map((item) => {
          return item
        })

        this.selectedTableData = [...this.selectedTableData, ...multipleSelection]

        this.multipleSelection.forEach(item => {
          const index = this.tableData.findIndex(v => v.id === item.id)
          this.tableData.splice(index, 1)
        })
        this.syncSelectedData()
      }
    },
    toLeft() {
      if (this.selectedMultipleSelection.length) {
        this.tableData = [...this.tableData, ...this.selectedMultipleSelection]

        this.selectedMultipleSelection.forEach(item => {
          const index = this.selectedTableData.findIndex(v => v.id === item.id)
          this.selectedTableData.splice(index, 1)
        })
        this.syncSelectedData()
      }
    },
    clearAll() {
      this.selectedTableData = []
      this.tableData = this.dataSrouce.map((item) => {
        return item
      })
      this.syncSelectedData()
    },
    syncSelectedData() {
      this.$emit('syncTransferSelectedData', this.selectedTableData, this.transferType)
    }
  }
}
</script>
<style scoped lang="scss">
.transfer-container{
    margin-top:20px;
    margin-bottom: 20px;
}
.flex-column {
  height: 390px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .el-button {
    margin-top: 10px;
    margin-left: 0;
  }
}
/deep/ .table-card {
  .el-card__body {
    padding: 10px 5px;
  }
  .el-card__header {
    padding: 10px 5px;
    background: #EAEDF3;
    font-weight: 600;
  }
  .el-input__inner {
    padding: 0 8px;
    height: 20px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/components/Transfer.vue